import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import BooleanRen from "csi/heading/Boolean";
import declare from "dojo/_base/declare";

const HiggDefaultProcessRenderer = declare(BooleanRen, {
	/**
	 * @override
	 * Show a checkbox, checked if this is the default process
	 */
	_getValue(ctx: Context, h: Heading) {
		return ctx.getNode().$URL === ctx.getNodeParent().DefaultProcess;
	},
});

export = HiggDefaultProcessRenderer;